import {
  UPDATE_INCOME_START,
  UPDATE_INCOME_SUCCESS,
  UPDATE_INCOME_FAILURE,
  INCOME_SOURCE_CHANGED,
  INCOME_PAYG_TOGGLE_DETAILS,
  INCOME_EMPLOYER_TYPE_CHANGED,
  INCOME_PAYG_EDIT_DETAILS,
  BUILD_INCOME,
  INCOME_CHANGED,
} from './types'

export const updateIncomeStart = (payload) => ({
  type: UPDATE_INCOME_START,
  payload: payload,
})

export const updateIncomeSuccess = (payload) => ({
  type: UPDATE_INCOME_SUCCESS,
  payload: payload,
})

export const updateIncomeFailure = (payload) => ({
  type: UPDATE_INCOME_FAILURE,
  payload: payload,
})

export const incomeSourceChanged = (payload) => ({
  type: INCOME_SOURCE_CHANGED,
  payload: payload,
})

export const incomeEmployerTypeChanged = (payload) => ({
  type: INCOME_EMPLOYER_TYPE_CHANGED,
  payload: payload,
})

export const buildIncome = (payload) => ({
  type: BUILD_INCOME,
  payload: payload,
})

export const incomeChanged = (payload) => ({
  type: INCOME_CHANGED,
  payload: payload,
})

export const incomePaygToggleDetails = (payload) => ({
  type: INCOME_PAYG_TOGGLE_DETAILS,
  payload: payload,
})

export const incomePaygEditDetails = (detailName, payload) => ({
  type: INCOME_PAYG_EDIT_DETAILS,
  payload: [detailName, payload],
})
